import React from "react";
import { SectionCta } from "../SectionCta";
import { AUTHOR_PHOTO_URL } from "../../data/checkout";
const questions = ["What stage of dental development is the patient in?", "Which findings are expected during growth?", "Which findings deserve closer attention?", "What information is still missing?", "What are the potential benefits and limitations of early treatment?"];
export function AuthorSection() {
  return <section className="w-full bg-navy px-5 py-16 sm:py-24" data-id="element-69" data-mp="2ybw94xotbh45">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[400px_1fr] lg:gap-14" data-id="element-70" data-mp="338wgrd1b8rxd">
        <div className="lg:sticky lg:top-8 lg:self-start" data-id="element-71" data-mp="388sl5ddx6ldg">
          <p className="text-center text-sm font-bold uppercase tracking-widest text-gold lg:text-left" data-id="element-72" data-mp="38alr0qgpl1ke">
            Meet the author
          </p>
          <h2 className="mt-2 text-center font-serif text-4xl font-black text-white lg:text-left" data-id="element-73" data-mp="nitgbcs68sf2">
            Dr. Valeria Montes
          </h2>
          <p className="mt-1 text-center text-white/75 lg:text-left" data-id="element-74" data-mp="sfjtnscld9ws">
            Author of Interceptive Orthodontics Blueprint™
          </p>
          <img src={AUTHOR_PHOTO_URL} alt="Dr. Valeria Montes in her dental clinic" className="mx-auto mt-6 aspect-[4/5] w-full max-w-sm rounded-3xl object-cover object-top lg:max-w-none" data-id="element-75" data-mp="1z9a1lg15g0p7" />
        </div>

        <div data-id="element-76" data-mp="1q7u2w5jp5n0t">
          <h3 className="font-serif text-2xl font-bold text-white sm:text-3xl" data-id="element-77" data-mp="1qag4zpntjabn">A Message From Dr. Valeria Montes</h3>
          <div className="mt-5 space-y-4 text-lg leading-relaxed text-white/85" data-id="element-78" data-mp="1giit0gozkebv">
            <p data-id="element-79" data-mp="1ggfu175uvav0">
              When you’re learning about interceptive orthodontics, it’s easy to become focused on individual
              techniques, appliances, and treatment possibilities.
            </p>
            <p data-id="element-80" data-mp="17g16s29bzlov">But early orthodontic assessment involves a broader set of questions.</p>
          </div>

          <ul className="mt-6 space-y-3 border-l-2 border-wine pl-5" data-id="element-81" data-mp="xjoe97pivdvp">
            {questions.map(q => <li key={q} className="font-serif text-lg italic text-white" data-id="element-82" data-mp="nwc1lqm567rw">
                {q}
              </li>)}
          </ul>

          <div className="mt-6 rounded-2xl bg-wine p-5" data-id="element-83" data-mp="svx0k11bag4m">
            <p className="text-white/85" data-id="element-84" data-mp="dy4ojiuz49v6">And perhaps one of the most important questions:</p>
            <p className="mt-2 font-serif text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-85" data-mp="iwzct0bpmqmo">
              Is intervention indicated at this stage, or is monitoring the more appropriate consideration?
            </p>
          </div>

          <div className="mt-6 space-y-4 text-lg leading-relaxed text-white/85" data-id="element-86" data-mp="1bklluo3pingx">
            <p data-id="element-87" data-mp="wxilm9o020pw">These are the kinds of questions I want this collection to help you explore.</p>
            <p data-id="element-88" data-mp="11vbnwrm6makw">
              Interceptive Orthodontics Blueprint™ brings together educational resources on early assessment,
              mixed dentition, growth considerations, treatment planning, and clinical monitoring. My goal is
              to present these interconnected topics in a format that is easier to navigate and revisit.
            </p>
            <p data-id="element-89" data-mp="3f0gp7ah0unww">
              Rather than presenting appliances as automatic solutions to clinical findings, the collection
              emphasizes structured assessment and evidence-informed reasoning.
            </p>
            <p className="font-semibold text-white" data-id="element-90" data-mp="3jt9tjx8kvu8g">
              Because understanding when to consider treatment is just as important as understanding the
              treatment itself.
            </p>
            <p data-id="element-91" data-mp="2r4uhnjkqts1c">I invite you to explore the collection and use it as a companion to your professional education.</p>
          </div>
          <p className="mt-6 font-serif text-2xl font-bold italic text-gold" data-id="element-92" data-mp="355f0uguklpvd">— Dr. Valeria Montes</p>

          <SectionCta label="Get the collection by Dr. Valeria Montes" tone="dark" data-id="element-93" data-mp="311pe7wxghicz" />
        </div>
      </div>
    </section>;
}